import axios from "axios";
import {
  orderType,
  tablePageSizes,
} from "../../../ui-library/CustomTable/constants";
import { decrypt, getClaims } from "../../../../modules/login";
import { SurveyStatus } from "../../../../modules/constants";

// Constants
const SET_SURVEYS = "SET_SURVEYS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getAccountUsername = (state) => decrypt(state?.loginReducer.username);
const getTotalItems = (state) => state?.totalitems;
const getSearchedParams = (state) => state?.searchedParams;
const getSurveys = (state) => state?.surveys;
const canAnswerSurvey = (state) => getClaims(state, "survey.canAnswer");
const canViewResults = (state) => getClaims(state, "results.canView");
const getRole = (state) => decrypt(state?.loginReducer?.role);

// Default state
const initialState = {
  totalitems: null,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[1],
    search: "",
    orderBy: "status",
    order: orderType.DESC,
    status: SurveyStatus.ALL.id,
  },
  surveys: [],
};

export const surveysTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SURVEYS:
      const { surveys } = action;
      return {
        ...state,
        surveys: surveys.data,
        totalitems: surveys.records,
        searchedParams: action.searchedParams,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchSurveys = (searchedParams, participantId) => (dispatch) => {
  const params = {
    ...searchedParams,
    participantId,
  };
  return axios
    .get(`/api/surveys`, { params })
    .then((res) => {
      return dispatch({
        type: SET_SURVEYS,
        surveys: res.data,
        searchedParams,
      });
    })
    .catch((e) => {
      if (e?.message === "cancel") {
        return;
      }

      return Promise.reject(
        e.response?.data
          ? e.response.data
          : `There was an error while trying to fetch Surveys. ${e}`
      );
    });
};

export const mapStateToProps = (state) => {
  return {
    totalitems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    accountUsername: getAccountUsername(state),
    surveys: getSurveys(state),
    canAnswerSurvey: canAnswerSurvey(state),
    canViewResults: canViewResults(state),
    role: getRole(state),
  };
};

export const mapDispatchToProps = {
  fetchSurveys,
  resetState,
};
